/**
 * Employee Incident Rejection Types
 * Feature: individual rejection of a marking incident (ASIS-5248 / REXASIS-006)
 * Endpoint: PUT /v1/attendances/incidents/{incidentId}/rejection
 */

// Outcome discriminator constants — always HTTP 200, 'alreadyResolved' signals a
// concurrency conflict (someone else resolved the incident first).
export const INCIDENT_REJECTION_OUTCOME = {
  REJECTED: 'rejected',
  ALREADY_RESOLVED: 'alreadyResolved',
} as const;

export type IncidentRejectionOutcome =
  (typeof INCIDENT_REJECTION_OUTCOME)[keyof typeof INCIDENT_REJECTION_OUTCOME];

export interface LC_RejectIncidentIn {
  approverComment: string; // REQUIRED
}

// Real current state of an already-resolved incident (concurrency case).
export interface LC_IncidentRejectionStateOut {
  status: string;
  approvedByFullName: string | null;
  approverComment: string | null;
  updatedDate: string | null; // ISO date-time
}

export interface LC_RejectIncidentOut {
  outcome: IncidentRejectionOutcome;
  incidentId: number;
  newStatus: string;
  message: string;
  updatedDate: string | null; // ISO date-time
  // Only populated when outcome === 'alreadyResolved'.
  currentState: LC_IncidentRejectionStateOut | null;
}
